import { CatHeading } from 'blocks-nextjs/blocks-react/components/Heading';
import { CatTextLink } from 'blocks-nextjs/blocks-react/components/TextLink';
import { ProductDealerPriceAvailability } from 'services/dealerPriceAvailability/types';
import { usePartDiagram } from 'hooks/use-part-diagram/parts-diagram-context';
import { LineItem } from 'types/parts-diagram';
import { TextLinkSize } from '@blocks-web-components/components/text-link/text-link.model';
import { capitalizeText } from '@cat-ecom/common/utils/commonUtils';

interface GetGroupPartTypeProps {
  partNumber: string;
  name: string;
  disambiguation: boolean;
  ieSystemControlNumber: string | null;
  price: ProductDealerPriceAvailability;
  handleOpen: (
    partNumber: string,
    price: string | ProductDealerPriceAvailability
  ) => void;
  lineItem?: LineItem;
  setDrawerActive: (drawerActive: boolean) => void;
  catHeadingClassName?: string;
  catLinkSize?: TextLinkSize;
  catTextCapitalize?: boolean;
}

const GetGroupPartType = ({
  partNumber,
  name,
  disambiguation,
  ieSystemControlNumber,
  price,
  handleOpen,
  lineItem,
  setDrawerActive,
  catHeadingClassName = '',
  catLinkSize,
  catTextCapitalize
}: GetGroupPartTypeProps) => {
  const { setClickedLineItem } = usePartDiagram();
  const displayCapitalizeName = catTextCapitalize ? capitalizeText(name) : name;
  return ieSystemControlNumber === null && !disambiguation ? (
    <CatTextLink
      data-testid="normal-group-part"
      onClick={() => {
        setDrawerActive(true);
        handleOpen(partNumber, price);
        if (lineItem) {
          setClickedLineItem(lineItem);
        }
      }}
      size={catLinkSize}
    >
      {partNumber}
      {name && `: ${displayCapitalizeName}`}
    </CatTextLink>
  ) : (
    <CatHeading variant="body" className={catHeadingClassName}>
      {partNumber}
      {name && `: ${name}`}
    </CatHeading>
  );
};

export default GetGroupPartType;
